<template>
  <div class="event-info-card">
    <div class="cs-textstyle-item-heading event-info-card__header">
      Event Detail
    </div>
    <div class="event-info-card__details">
      <div class="event-info-card__details-2rows">
        <div>
          <i class="cs-icons-calendar icon"></i>
        </div>
        <div class="event-info-card__details-second-row">
          <p class="cs-textstyle-paragraph-small-bold no-margin">
            {{ eventDate }}
          </p>
          <p class="cs-textstyle-paragraph-small no-margin">
            {{ eventStartTime }}
            - {{ eventEndTime }}
          </p>
        </div>
      </div>
      <div class="event-info-card__details-ticket">
        <i class="cs-icons-ticket icon"></i>
        <p
          class="cs-textstyle-paragraph-small-bold event-info-card__details-ticket-price"
        >
          Free
        </p>
      </div>
      <div class="event-info-card__details-2rows" v-if="event.city.name">
        <div>
          <i class="cs-icons-marker icon"></i>
        </div>
        <div class="event-info-card__details-second-row">
          <p
            class="cs-textstyle-paragraph-small-bold no-margin"
            v-if="event.city.name"
          >
            Event Location
          </p>
          <p class="cs-textstyle-paragraph-small-bold no-margin" v-else>
            Online Event
          </p>
          <p
            class="cs-textstyle-paragraph-small no-margin"
            v-if="event.city.name"
          >
            {{ event.city.name }}
          </p>
          <a v-else :href="event.meeting_link" target="_blank"
            >Click here to view the link</a
          >
        </div>
      </div>
      <cs-static-map
        v-if="event.city.name"
        :api-key="apiKey"
        :zoom="15"
        :center="center"
        class="events-static-map"
      ></cs-static-map>
      <div class="event-info-card__details-organiser">
        <p
          class="cs-textstyle-detail-heading event-info-card__details-organiser-title"
        >
          Organiser
        </p>
        <div>
          <cs-profile
            avatar-size="medium"
            avatar-position="left"
            :picture="event.group.picture"
            :name="event.group.name"
            :detail="organiserDescription"
          >
          </cs-profile>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
var days = [
  'Sunday',
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday'
];
var months = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December'
];
export default {
  props: ['event'],
  data() {
    return {
      apiKey: 'AIzaSyCMUTVTu0_welFWxPY0DN4-Mw0YfhGPBos'
    };
  },
  computed: {
    center() {
      return { lat: this.event.city.latitude, lng: this.event.city.longitude };
    },
    organiserDescription() {
      const div = document.createElement('div');
      div.innerHTML = this.event.group.description;
      return div.innerText;
    },
    eventDate() {
      const date = new Date(this.event.date_time);
      const day = days[date.getDay()];
      const month = months[date.getMonth()];
      const year = date.getFullYear();
      return `${day}, ${date.getDate()} ${month} ${year}`;
    },
    eventStartTime() {
      const start_time = new Date(this.event.date_time)
        .toLocaleTimeString(undefined, {
          timeZoneName: 'short',
          hour: '2-digit',
          minute: '2-digit'
        })
        .split(' ');
      return start_time[0] + ' ' + start_time[1];
    },
    eventEndTime() {
      const end_time = new Date(this.event.end_time).toLocaleTimeString(
        undefined,
        {
          timeZoneName: 'short',
          hour: '2-digit',
          minute: '2-digit'
        }
      );
      return end_time;
    }
  }
};
</script>

<style scoped>
.event-info-card {
  padding: 15px;
  border: 1px solid var(--cs-gray-02);
  border-radius: 5px;
  padding-right: 15px;
}
.event-info-card__header {
  border-bottom: 1px solid var(--cs-gray-02);
  padding-bottom: 15px;
  color: var(--cs-gray-06);
}
.event-info-card__details-2rows {
  display: flex;
}
.no-margin {
  margin: 0px;
}
.event-info-card__details-second-row {
  margin-left: 20px;
  color: var(--cs-gray-05);
}
.event-info-card__details {
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding-top: 20px;
}
.event-info-card__details-ticket {
  display: flex;
  align-items: center;
}
.event-info-card__details-ticket-price {
  margin: 0px;
  margin-left: 20px;
  color: var(--cs-gray-05);
}
.event-info-card__details-organiser >>> .cs-profile__main {
  padding: 0px !important;
}
.event-info-card__details-organiser >>> .cs-profile__content-detail {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  color: var(--cs-gray-05);
}
.event-info-card__details-organiser >>> .cs-profile__content-name {
  color: var(--cs-gray-05);
}
.event-info-card__details-organiser-title {
  color: var(--cs-gray-06);
}
.event-info-card__details-second-row a {
  text-decoration: none;
  color: var(--cs-primary-base);
  font-weight: normal;
}
.icon {
  font-size: 24px;
}
</style>
